import React from 'react'
import { makeStyles, Fab } from '@material-ui/core'
import { Icon } from 'packages/eid-icons'

const useStyles = makeStyles((theme) => ({
    root: (props) => ({
        margin: theme.spacing(1),
        textTransform: 'capitalize',
        fontSize: '14px',
        height: '31px !important',

        color: '#307fc1 !important',
        backgroundColor: '#ffffff !important',
        border: '1px solid #307fc1',
        margin: 0,
        boxShadow: 'none',
        minWidth: '65px !important',

        '&:hover': {
            color: '#ffffff !important',
            backgroundColor: '#307fc1 !important',
            borderColor: 'transparent !important',

            '& svg': {
                color: '#ffffff !important',
            },
        },
        ...props.styles,
    }),
    icon: {
        color: '#307fc1',
        marginLeft: 6,
    },
}))
const ViewDetailsButton = ({ color, styles, children, ...rest }) => {
    const classes = useStyles({ color, styles })
    return (
        <Fab variant="extended" size="small" className={classes.root} {...rest}>
            {children}
            <Icon name="SmallArrow" className={classes.icon}></Icon>
        </Fab>
    )
}

export default ViewDetailsButton
